/* filter.icon.svg.js */

"use strict";
module.exports = {
    icon: `
            <svg viewBox="0 0 18.5 18.5" preserveAspectRatio="none">
            <path class="foreground-gl" d="M3.3,2.8c0.6,0,12.1,0,12.7,0c0.6,0,0.9,0.7,0.5,1.1S11.4,9,11.4,9s0,6.6,0,7.2c0,0.5-0.5,0.8-1,0.5C10,16.4,8,15,8.2,15.1c0.2,0.1-0.3-0.1-0.3-0.4c0-0.3,0-5.7,0-5.7S3.1,4.2,2.8,3.8S2.8,2.8,3.3,2.8z"/>
            </svg>`,
    toggledIcon: `    
            <svg viewBox="0 0 18.5 18.5" preserveAspectRatio="none">
            <path style="fill:#A6CE3A" d="M16.9,0c1,0.9,1.1,2.4,0.2,3.4l-1,1.2c0,0,0,0,0,0c0,0,0,0,0,0l-2.8,3.3c-1.2,1.4-2.3,2.7-2.3,2.7s0,5.7,0,6.2c0,0.5-0.5,0.8-1,0.5c-0.4-0.3-2.4-1.7-2.3-1.6c0.2,0.1-0.3-0.1-0.3-0.4s0-4.8,0-4.8s-4.8-5.7-5.1-6s0-1.1,0.5-1.1c0.4,0,4.3,0,7.7,0l2.7-3.2c0.1-0.1,0.2-0.2,0.3-0.2h-0.5H2C0.9,0,0,0.9,0,2v14.4c0,1.2,1,2.1,2.1,2.1h14.3c1.3,0,2.3-1,2.3-2.3v-14C18.8,1.1,18,0.1,16.9,0z"/>
            <path class="foreground-gl" d="M9.4,9.9C9.4,9.9,9.4,9.9,9.4,9.9c-0.4,0-0.7-0.2-1-0.4L6,6.6C5.6,6,5.7,5.2,6.2,4.8S7.5,4.4,8,5l1.5,1.8l4.8-5.6C14.7,0.6,15.5,0.6,16,1c0.5,0.5,0.6,1.2,0.1,1.8l-5.8,6.7C10.1,9.8,9.8,9.9,9.4,9.9z"/>
            </svg>`,
};
